import type { TranslationMessages } from '../../types';

// Import all staff translation sections
import { common as commonFields } from './common';
import { dashboard } from './dashboard';
import { profile } from './profile';
import { attendance } from './attendance';
import { timesheet } from './timesheet';
import { points } from './points';
import { point_store } from './point_store';
import { ranking } from './ranking';
import { badges } from './badges';
import { schedule } from './schedule';
import { checklist } from './checklist';
import { tabs } from './tabs';
import {
  shift_bonus_config,
  shift_bonus_config_desc,
  bonus_config,
} from './bonus_config';
import { shift_planning } from './shift_planning';
import { shift_switching } from './shift_switching';
import { point_earning } from './point_earning';
import { header } from './header';
import { pin } from './pin';
import { common as commonUI } from './common_ui';
import { rating } from './rating';
import { leave } from './leave';

// Combine all staff translations
export const staff: TranslationMessages = {
  ...commonFields,
  dashboard,
  profile,
  attendance,
  timesheet,
  points,
  point_store,
  ranking,
  badges,
  schedule,
  checklist,
  tabs,
  shift_bonus_config,
  shift_bonus_config_desc,
  bonus_config,
  shift_planning,
  shift_switching,
  point_earning,
  header,
  pin,
  common: commonUI,
  rating,
  leave,
};
